// Authentication guards for route protection
angular.module('dentalLinksServices')

// Standard user guard (doctor, admin, aux)
.factory('StandardUserGuard', ['Auth', 'USER_ROLES', function(Auth, USER_ROLES) {
    // Authorization is centrally handled in $stateChangeStart. This resolve is a no-op.
    return true;
}])

// Create referral specific guard that can redirect to guestOrLogin
// Authorization and redirect are handled in $stateChangeStart and pageshow (bfcache).
// Resolve must return synchronously - a never-resolving promise can break controller scope
// and cause referral_id to be undefined when uploading attachments.
.factory('CreateReferralGuard', ['Auth', 'USER_ROLES', function(Auth, USER_ROLES) {
    return true;
}])

// Super user guard
.factory('SuperUserGuard', ['Auth', 'USER_ROLES', function(Auth, USER_ROLES) {
    // Authorization is centrally handled in $stateChangeStart. This resolve is a no-op.
    return true;
}]);
